import { createV3Queries } from "@query/utils/createV3Queries";
import { payersApi } from "@api";
import { QUERY_PAYER_ROWS } from "../../query/search/payer/queries/useQueryPayerRows";
import { QUERY_PAYER_ROWS_ALL } from "../../query/search/payer/queries/useQueryPayerRowsAll";
import { QUERY_PAYER_ROWS_SUMMARY } from "../../query/search/payer/queries/useQueryPayerRowsSummary";
import { QUERY_PAYER_QUICKBOOKS_MAPPING } from "../hooks/useQueryPayerQuickbooksMapping";
import { queriesPayerRows } from "./queriesPayerRows";

// Both sides of archive/restore move a payer between the active clients list and
// the archived one, so each must refresh the clients list (v3 searchPayerRows)
// plus the still-v1 payer-row search caches the assignment pickers read — the
// name-derived defaults only cover this registry's own (payersApi) reads. Always
// true for these methods, so it lives here rather than at each call site.
const clientListDependencies = () => [
  queriesPayerRows.searchPayerRows.queryKeyBase,
  QUERY_PAYER_ROWS,
  QUERY_PAYER_ROWS_ALL,
  QUERY_PAYER_ROWS_SUMMARY
];

export const queriesPayers = createV3Queries("payersApi", payersApi, {
  // Archive: deletePayer soft-deactivates, so the client drops out of both.
  deletePayer: () => ({
    dependencies: clientListDependencies
  }),
  // Restore: restorePayer (WIN-15189) reactivates, the inverse of the above.
  restorePayer: () => ({
    dependencies: clientListDependencies
  }),
  // The QuickBooks mapping is read off the RAW payer body, because the typed
  // `Payer` drops `quickbooksItemId` (see useQueryPayerQuickbooksMapping). That
  // hand-written key is outside this registry, so the name-derived defaults
  // don't reach it and the panel would keep rendering the pre-write mapping.
  updatePayer: () => ({
    dependencies: () => [QUERY_PAYER_QUICKBOOKS_MAPPING]
  })
});
